import { Card } from "@/components/ui/card";
import { ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

type NativeListCardProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  meta?: React.ReactNode;
  badges?: React.ReactNode;
  onClick?: () => void;
  className?: string;
};

/** Compact tappable row card for native admin/dealer lists (replaces wide tables). */
export const NativeListCard = ({
  title,
  subtitle,
  meta,
  badges,
  onClick,
  className,
}: NativeListCardProps) => (
  <Card
    className={cn(
      "p-3 cursor-pointer active:bg-accent/10 transition-colors border shadow-sm",
      className,
    )}
    onClick={onClick}
    role={onClick ? "button" : undefined}
  >
    <div className="flex items-start gap-2">
      <div className="flex-1 min-w-0 space-y-1">
        <div className="font-medium text-sm leading-tight">{title}</div>
        {subtitle && (
          <p className="text-xs text-muted-foreground line-clamp-2">{subtitle}</p>
        )}
        {meta && <p className="text-xs text-muted-foreground">{meta}</p>}
        {badges && <div className="flex flex-wrap gap-1 pt-0.5">{badges}</div>}
      </div>
      {onClick && (
        <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground mt-0.5" />
      )}
    </div>
  </Card>
);
